const STORAGE_KEY = 'portal_invite_code'

function normalize(code) {
  if (code == null) {
    return ''
  }
  return String(code).trim().toUpperCase()
}

export function setStoredInviteCode(code) {
  const normalized = normalize(code)
  if (!normalized) {
    return
  }
  try {
    localStorage.setItem(STORAGE_KEY, normalized)
  } catch (e) {
    /* ignore */
  }
}

export function getStoredInviteCode() {
  try {
    return normalize(localStorage.getItem(STORAGE_KEY))
  } catch (e) {
    return ''
  }
}

export function captureInviteFromRoute(route) {
  if (!route || !route.query) {
    return
  }
  const code = route.query.i || route.query.invite
  if (code) {
    setStoredInviteCode(code)
  }
}

export function appendInviteQuery(path) {
  const code = getStoredInviteCode()
  if (!code || !path || path.indexOf('?') >= 0) {
    return path
  }
  return path + '?i=' + encodeURIComponent(code)
}

export async function copyText(text) {
  if (!text) {
    return false
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text)
    return true
  }
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.style.position = 'fixed'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  const ok = document.execCommand('copy')
  document.body.removeChild(textarea)
  return ok
}
